import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './CollectionTile.module.scss';

const CollectionTile = ({ count, image, section, slug, title, user }) => (
  <Link className={styles.tile} to={`/${section}/${slug}${user ? `?user=${user}` : ``}`}>
    {image && <img className={styles.image} src={image.localFiles[0].childImageSharp.fluid.src} />}
    <h1 className={styles.title}>{title}</h1>
    {count && <span className={styles.count}>{count}</span>}
  </Link>
);

CollectionTile.propTypes = {
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default CollectionTile;
